import React from 'react';
import PropTypes from 'prop-types';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

function getStyles() {
  return {
    UploadSummaryContainer: {
      '& table': {
        margin: '20px 0',
        textAlign: 'center',
        '& th, td': {
          padding: '5px 20px',
        },
      },
      '& .discard-btn': {
        marginLeft: '10px',
      },
    },
  };
}

function UploadSummary(props) {
  const {
    classes, result, i18n, stage, downloadPath,
  } = props;

  const previewBtns = (
    <div className="upload-btns">
      <PrimaryButton text={i18n.getString(_TL_('Save bookings'))} allowDisabledFocus disabled={result.ErrorCount > 0} onClick={props.onApply} />
      {downloadPath && <DefaultButton className="discard-btn" text={i18n.getString(_TL_('Download report'))} allowDisabledFocus onClick={props.onDownload} />}
      <DefaultButton className="discard-btn" text={i18n.getString(_TL_('Discard'))} onClick={props.onDiscard} />
    </div>
  );

  const commitBtns = (
    <div className="upload-btns">
      <PrimaryButton text={i18n.getString(_TL_('Download report'))} allowDisabledFocus onClick={props.onDownload} />
      <DefaultButton className="discard-btn" text={i18n.getString(_TL_('Close'))} onClick={props.onClose} />
    </div>
  );
  return (
    <div className={classes.UploadSummaryContainer}>
      <div className="upload-result">
        <h3>{i18n.getString(stage === 'preview' ? _TL_('Preview bookings') : _TL_('Saved bookings'))}</h3>
        <table border="1" bordercolor="#ddd">
          <thead>
            <tr>
              <th />
              <th>{i18n.getString(stage === 'preview' ? _TL_('To be reconciled') : _TL_('Reconciled'))}</th>
              <th>{i18n.getString(_TL_('Errors'))}</th>
              <th>{i18n.getString(_TL_('Total'))}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{i18n.getString(_TL_('Booking details'))}</td>
              <td>{result.SuccessCount}</td>
              <td>{result.ErrorCount}</td>
              <td>{result.BookingCount}</td>
            </tr>
          </tbody>
        </table>
      </div>
      {stage === 'preview' ? previewBtns : commitBtns}
    </div>
  );
}

UploadSummary.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  classes: PropTypes.shape({}).isRequired,
  stage: PropTypes.string.isRequired,
  downloadPath: PropTypes.string.isRequired,
  result: PropTypes.shape({}).isRequired,
  onApply: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const Wrapped = withDefaultStyles(UploadSummary, getStyles);

export default Wrapped;
